<template>
    <div class="cert-status">
        <span class="cert-status__badge" :class="issued ? 'is-issued' : 'is-pending'">
            <v-icon size="14" aria-hidden="true">
                {{ issued ? 'mdi-check' : 'mdi-clock-outline' }}
            </v-icon>
            {{ issued ? $t('student.certificates.issued') : $t('student.certificates.pending') }}
        </span>
        <p class="cert-status__date">{{ dateText }}</p>
    </div>
</template>

<script>
    export default {
        name: 'CertificateStatus',
        props: {
            issued: { type: Boolean, default: false },
            dateText: { type: String, default: '' },
        },
    };
</script>

<style scoped>
    .cert-status {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    }

    .cert-status__badge {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 3px 7px;
        border-radius: 7px;
        font-size: 0.62rem;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
    }

    .cert-status__badge.is-pending {
        background: var(--certs-badge-pending-bg, #f3f4f6);
        color: var(--certs-badge-pending, #4b5563);
    }

    .cert-status__badge.is-issued {
        background: var(--certs-badge-issued-bg, #ecfdf3);
        color: var(--certs-badge-issued, #047857);
    }

    .cert-status__date {
        margin: 0;
        font-size: 0.72rem;
        color: var(--certs-muted, #6b7280);
    }
</style>
